import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider
} from '@mui/material';

const ColorBox = ({ className }) => (
  <Box
    className={className}
    sx={{
      width: 20,
      height: 20,
      borderRadius: 0.5,
      mr: 1,
      border: '1px solid #999'
    }}
  />
);

const LegendItem = ({ colorClass, text }) => (
  <Box display="flex" alignItems="center" mb={1}>
    <ColorBox className={colorClass} />
    <Typography variant="body2">{text}</Typography>
  </Box>
);

const Section = ({ title, children }) => (
  <>
    <Typography variant="subtitle1" fontWeight="bold" mt={2} mb={1}>
      {title}
    </Typography>
    {children}
    <Divider sx={{ my: 2 }} />
  </>
);

const ColorLegendDialog = ({ open, onClose, classes }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Diccionario de Colores</DialogTitle>

      <DialogContent dividers>

        {/* ODOMETER */}
        <Section title="Comparación de Odómetros">
          <LegendItem
            colorClass={classes.cellGreen}
            text="Diferencia ≤ 100 millas → Correcto"
          />
          <LegendItem
            colorClass={classes.cellLightRed}
            text="Diferencia > 100 millas → Revisar"
          />
        </Section>

        {/* DISTANCE */}
        <Section title="Comparación de Distancia">
          <LegendItem
            colorClass={classes.cellGreen}
            text="Diferencia ≤ 1 milla → Correcto"
          />
          <LegendItem
            colorClass={classes.cellLightRed}
            text="Diferencia > 1 milla → Revisar"
          />
        </Section>

        {/* MPG REAL */}
        <Section title="MPG Real">
          <LegendItem
            colorClass={classes.rowBlue}
            text="Fila inicial → Primer registro (MPG NO Calculado)"
          />
          <LegendItem
            colorClass={classes.cellBlack}
            text="MPG = 0"
          />
          <LegendItem
            colorClass={classes.cellBrightGreen}
            text="MPG ≥ 7 → Excelente"
          />
          <LegendItem
            colorClass={classes.cellGreenMedium}
            text="MPG entre 6 y 6.99 → Bueno"
          />
          <LegendItem
            colorClass={classes.cellYellow}
            text="MPG entre 4 y 5.99 → Bajo"
          />
          <LegendItem
            colorClass={classes.cellRed}
            text="MPG entre 0 y 3.99 → Muy Bajo"
          />
        </Section>

        {/* TOLERANCE */}
        <Section title="Tolerancia % (Real vs PC)">
          <LegendItem
            colorClass={classes.cellBrightGreen}
            text="Dentro de ±7%"
          />
          <LegendItem
            colorClass={classes.cellRed}
            text="Fuera de ±7%"
          />
        </Section>

        {/* DIFERENCIA */}
        <Section title="Diferencia de Combustible (GLLS)">
          <LegendItem
            colorClass={classes.cellRed}
            text="Valor negativo → Consumo mayor al agregado"
          />
          <LegendItem
            colorClass={classes.cellPurple}
            text="Valor positivo → Agregado mayor al consumo"
          />
        </Section>

        {/* LOCATION */}
        <Section title="Ubicación de Reseteo">
          <LegendItem
            colorClass={classes.locationLaredo}
            text="Laredo"
          />
          <LegendItem
            colorClass={classes.locationColombia}
            text="Colombia"
          />
        </Section>

        {/* USA UNIT */}
        <Section title="Unidad USA">
          <LegendItem
            colorClass={classes.cellDarkRed}
            text="Unidad de tipo USA"
          />
        </Section>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorLegendDialog;
